import { useRefundPOS } from "@/hooks/useRefundPOS";
import { Button, Modal } from "barte-design-system";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const ConfirmeModal = ({setReload, setOpenResponseModal, setResponseModal, openModal, setOpenModal, amount }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [loading,setLoading] = useState(false)
    const { id } = useParams();
    const { createRefund } = useRefundPOS();
    const user = JSON.parse(localStorage.getItem("barte-user-info"));
    useEffect(() => {
        if (openModal) {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, [openModal]);

    const handleClose = () => {
        setIsOpen(false);
        setOpenModal(false)
    };

    async function getResponse() {
        setLoading(true)
        try {
            const data = {
                value: Number(amount),
                updated_by: user?.email
            }
            const response = await createRefund(id, data)
            setResponseModal(response)
            setOpenResponseModal(true)
            setOpenModal(false)
        } catch (error) {
            setResponseModal({ ...error?.response?.data?.errors?.[0], error: true })
            setOpenResponseModal(true)
            setOpenModal(false)
        }finally {
            setLoading(false)
        }
    }

    const formattedAmount = Number(amount) > 0 ? Number(amount).toFixed(2) : "0.00";

    return (
        <Modal
            isOpen={isOpen}
            title="Deseja estornar essa cobrança?"
            onClose={handleClose}
            footer={{
                primaryButton: {
                    children: "Estornar",
                    onClick: getResponse,
                    loading,
                },
                secondaryButton: {
                    children: "Cancelar",
                    onClick: handleClose,
                    variant: "outline",
                },
            }}
        >
            <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                <img width="24" height="24" src="/images/icons/ExclamationCircle.svg" alt="" />
                <p style={{ fontSize: "0.875rem" }}>
                    {`Será estornado o valor de R$ ${formattedAmount} e essa ação não poderá ser desfeita.`}
                </p>
            </div>
        </Modal>
    );
};
